import { render, staticRenderFns } from "./Generals.vue?vue&type=template&id=4eabc27a&scoped=true&"
import script from "./Generals.vue?vue&type=script&lang=js&"
export * from "./Generals.vue?vue&type=script&lang=js&"
import style0 from "./Generals.vue?vue&type=style&index=0&id=4eabc27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eabc27a",
  null
  
)

export default component.exports